// @flow

import { css } from "styled-components";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import { mediumParagraph, ADDRESS_NOT_FOUND_ID } from "@nested/brand";
import { Button, ButtonLink } from "@nested/component-library";
import { QuestionWrapper, Heading } from "../components";
import {
  type State,
  formStateUpdateAction,
} from "../components/MultiStageForm/ducks";
import { options } from "./CustomerIntent";

const buttonGroup = css`
  margin-top: 30px;
  * {
    margin-bottom: 10px;
    margin-right: 10px;
  }
`;

const fieldStyle = css`
  ${mediumParagraph}
  margin-bottom: 10px;
`;

export const PersonalInformationAlreadySaved = () => {
  const formState: State = useSelector((state) => state.onboardingForm);
  const dispatch = useDispatch();
  const history = useHistory();
  const intent = options.find((o) => o.value === formState.customerIntent);

  return (
    <>
      <QuestionWrapper
        data-test="personal-information-already-saved"
        next={() => {
          dispatch(formStateUpdateAction({ dealId: undefined }));
          history.push("/get-started");
        }}
      >
        <Heading className="fs-exclude">
          {formState.name?.firstName}, we've already got your details. Does this
          look right?
        </Heading>
        <div>
          <div css={fieldStyle}>
            <strong>Address:</strong> {getAddress(formState)}
          </div>
          <div css={fieldStyle}>
            <strong>Where are you in your home move:</strong> {intent?.label}
          </div>
          <div className="fs-exclude" css={fieldStyle}>
            <strong>Email:</strong> {formState.email?.email}
          </div>
          <div className="fs-exclude" css={fieldStyle}>
            <strong>Name:</strong> {formState.name?.firstName}{" "}
            {formState.name?.lastName}
          </div>
          <div className="fs-exclude" css={fieldStyle}>
            <strong>Telephone:</strong> {formState.phone}
          </div>
        </div>
        <div css={buttonGroup}>
          <ButtonLink
            to="/get-started/finishing-up"
            size="large"
            type="primary"
          >
            Looks good, continue
          </ButtonLink>
          <Button data-test="start-again" size="large">
            No, make changes
          </Button>
        </div>
      </QuestionWrapper>
    </>
  );
};

const getAddress = ({ address, manualAddress }) => {
  if (!address) {
    return null;
  }
  if (address.id === ADDRESS_NOT_FOUND_ID) {
    if (!manualAddress) {
      return null;
    }
    return [
      manualAddress.lineOne,
      manualAddress.lineTwo,
      manualAddress.city,
      manualAddress.postcode,
    ]
      .filter((s) => s !== "")
      .join(", ");
  }

  return address.label;
};
